import { Heading, Stack, Text } from '@chakra-ui/react'
import FirestoreUser from '../../../types/FirestoreUser'
import { formatDateFull } from '../../../utils/formatDate'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'

interface ProfileHeaderProps {
  user: FirestoreUser | null | undefined
}

const ProfileHeader = ({ user }: ProfileHeaderProps) => {
  const purpleBubbleContent = usePurpleBubblesText('Profile')

  return (
    <Stack spacing={2}>
      <Heading>Profile</Heading>
      <Text fontSize='sm'>Patient ID: #{user?.patientId}</Text>
      {user?.email && <Text fontSize='sm'>{user.email}</Text>}
      {user?.createdAt && (
        <Text fontSize='sm'>
          Joined Registry: {formatDateFull(user.createdAt)}
        </Text>
      )}
      {purpleBubbleContent?.text && (
        <PurpleBubbleContent text={purpleBubbleContent.text} />
      )}
    </Stack>
  )
}

export default ProfileHeader
